/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Material_Is_ActiveInputs */

const vi_agri_material_is_active = /** @type {(inputs: Agri_Material_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang sử dụng`)
};

/**

* @param {Agri_Material_Is_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_material_is_active = /** @type {((inputs?: Agri_Material_Is_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Material_Is_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_material_is_active(inputs)
});